import React, { useEffect } from "react";
import WOW from "wowjs"
import "./Blog.css"

const Blog = () => {

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, [])


  return (
       <section class="wow fadeIn blog-section spad">
           <div class="container">
                <div
                  class="page-header text-center wow fadeInDown"
                  data-wow-delay="0.4s"
                >
                  <h2 style={{ color: "#292f4d", fontSize:"50px" }}>Blog</h2>
                  <div class="devider"></div>
                </div>
              </div>
        <div class="container">
            
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-8 order-2 order-lg-1">
                    <div class="blog-sidebar">
                        
                        <div class="recent-post">
                            <h4>Recent Post</h4>
                            <div class="recent-blog">
                                <a href="#" class="rb-item">
                                    <div class="rb-pic">
                                        <img src="img/blog/recent-1.jpg" alt=""/>
                                    </div>
                                    <div class="rb-text">
                                        <h6>Title</h6>
                                        <p>Category <span>- May 19, 2019</span></p>
                                    </div>
                                </a>
                                <a href="#" class="rb-item">
                                    <div class="rb-pic">
                                        <img src="img/blog/recent-2.jpg" alt=""/>
                                    </div>
                                    <div class="rb-text">
                                        <h6>Title</h6>
                                        <p>Category <span>- May 19, 2019</span></p>
                                    </div>
                                </a>
                                <a href="#" class="rb-item">
                                    <div class="rb-pic">
                                        <img src="img/blog/recent-3.jpg" alt=""/>
                                    </div>
                                    <div class="rb-text">
                                        <h6>Title</h6>
                                        <p>Category <span>- May 19, 2019</span></p>
                                    </div>
                                </a>
                                <a href="#" class="rb-item">
                                    <div class="rb-pic">
                                        <img src="img/blog/recent-4.jpg" alt=""/>
                                    </div>
                                    <div class="rb-text">
                                        <h6>Title</h6>
                                        <p>Category <span>- May 19, 2019</span></p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="col-lg-9 order-1 order-lg-2">
                    <div class="row">
                        
                        <div class="wow fadeInDown col-lg-6 col-sm-6" data-wow-delay="0.1s">
                            <div class="blog-item">
                                <div class="bi-pic">
                                    <img src="img/blog/blog-1.jpg" alt=""/>
                                </div>
                                <div class="bi-text">
                                    <a href="./blog-details.html">
                                        <h4>Title</h4>
                                    </a>
                                    <p>Category <span>- May 19, 2019</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="wow fadeInDown col-lg-6 col-sm-6" data-wow-delay="0.1s">
                            <div class="blog-item">
                                <div class="bi-pic">
                                    <img src="img/blog/blog-2.jpg" alt=""/>
                                </div>
                                <div class="bi-text">
                                    <a href="./blog-details.html">
                                        <h4>Title</h4>
                                    </a>
                                    <p>Category <span>- May 19, 2019</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="wow fadeInDown col-lg-6 col-sm-6" data-wow-delay="0.1s">
                            <div class="blog-item">
                                <div class="bi-pic">
                                    <img src="img/blog/blog-3.jpg" alt=""/>
                                </div>
                                <div class="bi-text">
                                    <a href="./blog-details.html">
                                        <h4>Title</h4>
                                    </a>
                                    <p>Category <span>- May 19, 2019</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="wow fadeInDown col-lg-6 col-sm-6" data-wow-delay="0.1s">
                            <div class="blog-item">
                                <div class="bi-pic">
                                    <img src="img/blog/blog-4.jpg" alt=""/>
                                </div>
                                <div class="bi-text">
                                    <a href="./blog-details.html">
                                        <h4>Title</h4>
                                    </a>
                                    <p>Category <span>- May 19, 2019</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="wow fadeInDown col-lg-6 col-sm-6" data-wow-delay="0.1s">
                            <div class="blog-item">
                                <div class="bi-pic">
                                    <img src="img/blog/blog-5.jpg" alt=""/>
                                </div>
                                <div class="bi-text">
                                    <a href="./blog-details.html">
                                        <h4>Title</h4>
                                    </a>
                                    <p>Category <span>- May 19, 2019</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="wow fadeInDown col-lg-6 col-sm-6" data-wow-delay="0.1s">
                            <div class="blog-item">
                                <div class="bi-pic">
                                    <img src="img/blog/blog-6.jpg" alt=""/>
                                </div>
                                <div class="bi-text">
                                    <a href="./blog-details.html">
                                        <h4>Title</h4>
                                    </a>
                                    <p>Category <span>- May 19, 2019</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </section>
  );
};

export default Blog;
